import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { Input } from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { useToast } from '@chakra-ui/react'
import "./modalEditTask.css"

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Textarea


} from "@chakra-ui/react";
import ChilMNodal from "../childModal/childModal";
import CommentBox from "../commentBox/commentBox.jsx";
import Shablon from "../shablon/shablon.jsx";

import Metka from "../metka/metka.jsx";
import Status from "../status/status.jsx";
import SelectMarketPlaceEdit from "../selectMarketPlaceEdit/SelectMarketPlaceEdit";
import ChilMNodalEdit from "../childModalEdit/childModalEdit";
import { getMyCompany } from "../../../../redux/reducer/getCompany/action/action";
import UploadFileTaskMenegerEdit from "../uploadFile/uploadFileEdit";
import Perfomer from "../perfomer/perfomer";
import PerfomerEdit from "../perfomerEdit/perfomerEdit";
import axios from "axios";
import StatusEdit from "../status/statusEdit";
import MetkaEdit from "../metka/editMetka";
import DropdownMobilePioritet from "../tableTask/editPrioritetForMobile/editPrioritetForMobile";
import DropdownMobileStatus from "../tableTask/EditStatusForMobile/editStatusForMobile";
import "./modalEditTaskDark.css"
function ModalEditTask({ editAllTask, itemID, update, allitem, data, handleGetNotify, onlineUsers,index }) {
  const dispatch = useDispatch();
  const getmyinfo = useSelector((allWorkers) => allWorkers);
  const myinfos = useSelector(data => data.getMyImageReducer);
  const [show, setShow] = useState(false);
  const [child, setChild] = useState([]);
  const [message, setMessage] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const myModalEditTask = useRef(null)
  const [currentTask, setCurrentTask] = useState([]);
  const [comments, setComments] = useState([]);
  const [performer, setperformer] = useState([]);
  const [childperformer, setChildPerformer] = useState([]);
  const [templates, satTemplates] = useState("");
  const [taskName, satTtaskName] = useState("");
  const [templatesArray, satTemplatesArray] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endDateConfirm, setDndDateConfirm] = useState("");
  const [status, setStatus] = useState("");
  const [prioritet, setPrioritet] = useState("");
  const [metka, setMetka] = useState([]);
  const [ozon, setOzon] = useState([]);
  const [wb, setBw] = useState([]);
  const [classNameTask, setclassNameTask] = useState("greyClass");
  const [file, setfile] = useState("");
  const subTaskRed = useRef(null);
  const t = useRef(null);
  const dipatch = useDispatch();
  const [perfomerID, setperfomerID] = useState([]);
  const [load, setload] = useState(false)
  const toast = useToast()
  const [taskInfo, setTasktaskInfo] = useState("");
  const getDarkModoe = useSelector(darkModes => darkModes )


useEffect(()=>{
    // console.log(editAllTask,'editAllTask'); veradarcnum e  alltask arrayi mejin@ 
    //  console.log(itemID,'itemID'); veradracnum e id
      // console.log(allitem,'allitem'); veradarcnum e henc amboxj@
      //  console.log(data,'data'); 
},[])

  useEffect(() => {
    let currentDate = new Date().toISOString().slice(0, 16)







    dipatch(getMyCompany("/mycopany/getallcompany"));
    switch (prioritet) {
      case "Критический":

        setclassNameTask("urgentAndImportant");
        break;
      case "Важно":

        setclassNameTask("LilacClass");
        break;
      case "Срочно":

        setclassNameTask("yellowClass");
        break;
      default:

        setclassNameTask("greyClass");
    }
    setCurrentTask(editAllTask[0]);
    setCurrentTask([
      {
        child,
        taskName,
        msg: message,
        comments,
        performer,
        startDate,
        endDate,
        status,
        prioritet,
        ozon,
        wb,
        classNameTask,
        file,
        perfomerID,
        taskInfo,
        metka
      },
    ]);


  }, [
    comments,
    performer,
    templates,
    templatesArray,
    startDate,
    endDate,
    status,
    prioritet,
    metka,
    child,
    wb,
    ozon,
    taskName,
    file,
    taskInfo,


  ]);

  let array = [];

  const setSubStack = (e) => {

    if (e.key === "Enter") {

      setChild([
        ...child,
        {
          child: [],
          taskName,
          msg: message,
          comments: [],
          performer: [],
          startDate: "",
          endDate: "",
          status: "",
          prioritet: "",
          file: "",
          taskInfo: "",
          metka
        },
      ]);

      setMessage("");
      subTaskRed.current.style.overflow = "auto";

    }
  };



  const setSubStackBTN = (e) => {

    if (message != "") {

      setChild([
        ...child,
        {
          child: [],
          taskName,
          msg: message,
          comments: [],
          performer: [],
          startDate: "",
          endDate: "",
          status: "",
          prioritet: "",
          file: "",
          taskInfo: "",
          metka
        },
      ]);

      setMessage("");
      subTaskRed.current.style.overflow = "auto";

    }

  }


  useEffect(() => {
    setCurrentTask(editAllTask[0]);
    setBw(editAllTask[0].wb);
    setOzon(editAllTask[0].ozon);
    setChild(editAllTask[0].child);
    setComments(editAllTask[0].comments);
    setStartDate(editAllTask[0].startDate);
    setEndDate(editAllTask[0].endDate);
    setPrioritet(editAllTask[0].prioritet);
    setStatus(editAllTask[0].status);
    setperformer(editAllTask[0].performer);
    setclassNameTask(editAllTask[0].classNameTask);
    satTtaskName(editAllTask[0].taskName);
    setfile(editAllTask[0].file);
    setperfomerID(allitem.perfomerID)
    setTasktaskInfo(editAllTask[0].taskInfo)
    setMetka(editAllTask[0].metka)
  }, [data])


  const getarraa = (item, index) => {
    if (item.child.length === 0) {
      array = [];
      array.push(child);
      array[0][index].child.push();
    }
  };



  const showModal = () => {

    handleShow();


    setCurrentTask(editAllTask[0]);
    setBw(editAllTask[0].wb);
    setOzon(editAllTask[0].ozon);
    setChild(editAllTask[0].child);
    setComments(editAllTask[0].comments);
    setStartDate(editAllTask[0].startDate);
    setEndDate(editAllTask[0].endDate);
    setPrioritet(editAllTask[0].prioritet);
    setStatus(editAllTask[0].status);
    setperformer(editAllTask[0].performer);
    setclassNameTask(editAllTask[0].classNameTask);
    satTtaskName(editAllTask[0].taskName);
    setfile(editAllTask[0].file);
    setperfomerID(allitem.perfomerID)
    setMetka(editAllTask[0].metka)

  };

  const sendServer = () => {

    if (editAllTask[0] && editAllTask[0].perfomerID && editAllTask[0].perfomerID[0]) {
      if (editAllTask[0].perfomerID[0].workerID && perfomerID[0] && perfomerID[0].workerID) {
        if (editAllTask[0].perfomerID[0].workerID == perfomerID[0].workerID) {

        } else {
          if (perfomerID[0] && perfomerID[0].workerID) {
            if (perfomerID[0].email) {
         

              axios.post('/sendEmail/api', {
                perfomerEmail: perfomerID[0].email
              })
                .then(function (response) {
                 
                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {
          
              toast({
                position: "top",
                title: 'У этого пользователя нет электронной почты',
                description: "У этого пользователя нет электронной почты",
                status: 'error',
                duration: 2000,
                isClosable: true,
              });
            }

          }
        }
      }
    } else {
      if (perfomerID[0] && perfomerID[0].workerID) {
        if (perfomerID[0].email) {
      

          axios.post('/sendEmail/api', {
            perfomerEmail: perfomerID[0].email
          })
            .then(function (response) {
             
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log("no Email");
          toast({
            position: "top",
            title: 'У этого пользователя нет электронной почты',
            description: "У этого пользователя нет электронной почты",
            status: 'error',
            duration: 2000,
            isClosable: true,
          });
        }

      }
    }

    if (editAllTask[0].child.length > 0) {

      console.log(editAllTask[0].child);
    } else {
     
    }





    setload(true)
    allitem.perfomerID = perfomerID
    allitem.allmetka = metka

    axios.post('/findAndUpdateTask', {
      itemID,
      currentTask,
      allitem,
      perfomerID: allitem.perfomerID,
      allmetka: metka
    })
      .then(function (response) {
        console.log(response);
        update()
        setload(false)
        handleClose()
      })
      .catch(function (error) {
        console.log(error);
        setload(false)
      });




  };


  const HandleSetPerfomerId = (e) => {

    setperfomerID([e])
    setperformer(e)
  }

  const HandleDeletePerfomerId = (e) => {
    setperformer("")
    setperfomerID([])
  }

  function deleteItemByIndex(index) {
    setChild(prevArray => {
      const newArray = [...prevArray]; // Create a new array copy
      newArray.splice(index, 1); // Remove the element at the specified index
      return newArray; // Update the state with the modified array
    });
  }



  const handleDate = () => {

    axios.post('/notifyConfirm', {
      eidtTaskID: allitem._id,
      isChild: false,
      adminIDTask: allitem.creatorTasks.toString(),
      typenotify: "date",
      indexTask: 0,
      senderName: getmyinfo.getMayInfoReducer.myinfo.name,
      senderTel: getmyinfo.getMayInfoReducer.myinfo.tel,
      senderEmail: getmyinfo.getMayInfoReducer.myinfo.email,
      text: "",
      messageConfirm: endDateConfirm,
      taskName,
      oldDate: editAllTask[0].endDate,
      myAvatar: myinfos.users.myavatar

    })
      .then(function (response) {
        console.log(response);
        handleGetNotify()
        toast({
          position: "top",
          title: 'Отправлено на подтверждение постановщику задачи',
          description: "Отправлено на подтверждение постановщику задачи",
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleStatus = () => {
    axios.post('/notifyConfirm', {
      eidtTaskID: allitem._id,
      isChild: false,
      adminIDTask: allitem.creatorTasks.toString(),
      typenotify: "status",
      indexTask: 0,
      senderName: getmyinfo.getMayInfoReducer.myinfo.name,
      senderTel: getmyinfo.getMayInfoReducer.myinfo.tel,
      senderEmail: getmyinfo.getMayInfoReducer.myinfo.email,
      text: "",
      messageConfirm: endDate,
      taskName,
      oldDate: editAllTask[0].endDate,
      myAvatar: myinfos.users.myavatar

    })
      .then(function (response) {

        handleGetNotify()
        toast({
          position: "top",
          title: 'Отправлено на подтверждение постановщику задачи',
          description: "Отправлено на подтверждение постановщику задачи",
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleChangeFile = (e) => {
    console.log("prent");
    setfile(e)

  }

  useEffect(()=>{
    myModalEditTask.current.style.display = "none"
  },[])
  const handleOpenModal = () => {
    myModalEditTask.current.style.display = "flex"
  }

  const handleCloseModal = () => {
    myModalEditTask.current.style.display = "none"
  }

  return (
    <div  className={getDarkModoe.ToggleDarkModeReducer.chekced?"modalCreatTaskDark":"modalCreatTask"}>

      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30" fill="none" onClick={handleOpenModal}>
        <g filter="url(#filter0_d_1180_4175)">
          <ellipse cx="14" cy="13" rx="11" ry="11.25" fill="white" />
        </g>
        <path d="M15.6795 10.2756L16.3183 10.929L10.0275 17.3636H9.3887V16.7102L15.6795 10.2756ZM18.1791 6C18.0056 6 17.825 6.07102 17.6931 6.20597L16.4224 7.50568L19.0262 10.169L20.2969 8.86932C20.5677 8.59233 20.5677 8.14489 20.2969 7.8679L18.6721 6.20597C18.5333 6.06392 18.3597 6 18.1791 6ZM15.6795 8.26562L8 16.1207V18.7841H10.6038L18.2833 10.929L15.6795 8.26562Z" fill="#3B79F6" />
        <defs>
          <filter id="filter0_d_1180_4175" x="0" y="0.75" width="28" height="28.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1180_4175" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1180_4175" result="shape" />
          </filter>
        </defs>
      </svg>
      <div id="myModalEditTask" class="myModalEditTask" ref={myModalEditTask} >

        <div class="myModalEditTask-content">

          <div className="modalCont">
            <div className="perfomerAndShef">
              <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
              <PerfomerEdit performerS={performer} setperformerS={setperformer} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} onlineUsers={onlineUsers} />
                <PerfomerEdit performerS={performer} setperformerS={setperformer} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} onlineUsers={onlineUsers} />
              </div>
                <div className="statusANDprioritet">
                  <DropdownMobilePioritet isChild={false} prioritetGet={allitem.alltask[0].prioritet} allitemForStatus={allitem} index={index} update={update} />
                  <DropdownMobileStatus isChild={false} statusGet={allitem.alltask[0].status} allitemForStatus={allitem} index={index} update={update} />

                </div>
            </div>
            <div className="inputCreatTask">

              <div className="taskinputsDiv">
              <MetkaEdit setMetka={setMetka} metka={metka} />
                <p className="taskName">Введите название задачи</p>
                <input
                  placeholder="Введите название задачи"
                  className="nameTaskInput"
                  value={taskName}
                  onChange={(e) => satTtaskName(e.target.value)}
                />
                <div>

                </div>
                <div style={{margin:"30px 0"}}>
                      <p className="srok">Сроки</p>
                      {(() => {
                    
                    if (allitem.creatorTasks === getmyinfo.getMayInfoReducer.myinfo._id) {
                      return (
                        <div className="date">
                         
                          <label htmlFor="">
                          Дата начала:
                            <Input
                              size="sm"
                              type="datetime-local"
                              colorScheme="grey"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
  
                            />
                          </label>
                          <label htmlFor="">
                          Дата конца:
                            <Input
                              size="sm"
                              type="datetime-local"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
  
                          </label>
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path d="M9.5 20H2.5C1.39 20 0.5 19.1 0.5 18L0.51 4C0.51 2.9 1.39 2 2.5 2H3.5V1C3.5 0.45 3.95 0 4.5 0C5.05 0 5.5 0.45 5.5 1V2H13.5V1C13.5 0.45 13.95 0 14.5 0C15.05 0 15.5 0.45 15.5 1V2H16.5C17.6 2 18.5 2.9 18.5 4V10H16.5V8H2.5V18H9.5V20ZM19.63 14.99L20.34 14.28C20.73 13.89 20.73 13.26 20.34 12.87L19.63 12.16C19.24 11.77 18.61 11.77 18.22 12.16L17.51 12.87L19.63 14.99ZM18.92 15.7L13.91 20.71C13.73 20.89 13.47 21 13.21 21H12C11.72 21 11.5 20.78 11.5 20.5V19.29C11.5 19.02 11.61 18.77 11.79 18.58L16.8 13.57L18.92 15.7Z" fill="#3B79F6"/>
  </svg>
                        </div>
                      )
                    } else {
                      return (
                        <div className="date">
                          <label htmlFor="">
                          Дата начала:
                            <Input
                              size="sm"
                              type="datetime-local"
                              colorScheme="grey"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              disabled
  
                            />
                          </label>
                          <label htmlFor="">
                          Дата конца:
                            <Input
                              size="sm"
                              type="datetime-local"
                              defaultValue={endDate}
                              onChange={(e) => setDndDateConfirm(e.target.value)}
                              key={endDate}
                            />
                            <button onClick={handleDate} className="confirmEditDate">Запросить подтверждение</button>
                          </label>
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path d="M9.5 20H2.5C1.39 20 0.5 19.1 0.5 18L0.51 4C0.51 2.9 1.39 2 2.5 2H3.5V1C3.5 0.45 3.95 0 4.5 0C5.05 0 5.5 0.45 5.5 1V2H13.5V1C13.5 0.45 13.95 0 14.5 0C15.05 0 15.5 0.45 15.5 1V2H16.5C17.6 2 18.5 2.9 18.5 4V10H16.5V8H2.5V18H9.5V20ZM19.63 14.99L20.34 14.28C20.73 13.89 20.73 13.26 20.34 12.87L19.63 12.16C19.24 11.77 18.61 11.77 18.22 12.16L17.51 12.87L19.63 14.99ZM18.92 15.7L13.91 20.71C13.73 20.89 13.47 21 13.21 21H12C11.72 21 11.5 20.78 11.5 20.5V19.29C11.5 19.02 11.61 18.77 11.79 18.58L16.8 13.57L18.92 15.7Z" fill="#3B79F6"/>
  </svg>
                        </div>
                      )
                    }
                  })()}
               </div>
                <p className="taskDeskriptionText">Добавьте описание задачи</p>
                <textarea placeholder="Добавьте описание задачи" className="taskDeskription" defaultValue={taskInfo} onChange={(e) => setTasktaskInfo(e.target.value)} />
                <SelectMarketPlaceEdit
                  setBw={setBw}
                  setOzon={setOzon}
                  wbs={wb}
                  ozons={ozon}
                  show={show}
                />
                {/* <Shablon sendMessage={sendMessage} currentTask ={currentTask} perfomerID={perfomerID} receivedMessages={receivedMessages}  handleDelet={handleDelet} delLoad={delLoad} update={update} handleGetNotify={handleGetNotify} closeParent={handleClose}/> */}



              
                <UploadFileTaskMenegerEdit file={file} setfile={setfile} allitem={allitem} index={0} isChild={false} handleChangeFile={handleChangeFile} />
              </div>

              <div className="taskinputsDiv2">


                <div className={"subTask"} style={{ overflow: "auto" }} ref={subTaskRed}>
                 
                 
                 
                
                  <div className="addSubTask">
                    <p style={{ color: '#6A717F' }}>Подзадачи</p>
                    <div>
                      <input
                        className="SubTaskInput"
                        placeholder="Введите название подзадачи"
                        value={message}
                        onKeyDown={setSubStack}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      <button background={"#3182CE"} color={"white"} onClick={(e) => setSubStackBTN(e.target.value)}>Добавить</button>
                    </div>

                  </div>
                  {child?.map((item, index) => {

                    return (
                      <div onClick={() => getarraa(item, index)} className="childTaskCont" key={index}>

                        <div className="itemChild">
                           <h6>#{index+1}</h6>
                          <p>{item.msg}</p>
                          <p>{item.startDate.split("T").join(",")}</p>
                          {/* <p>{item.startDate.split("T").join(",")}-{item.endDate.split("T").join(",")}</p> */}
                          <p>{item.performer.name}</p>
                          <ChilMNodalEdit
                            item={item}
                            allaray={currentTask}
                            nameCurrentSubTask={item.msg}
                            sendServer={sendServer}
                            load={load}
                            editAllTask={editAllTask}
                            allitem={allitem}
                            index={index}
                            handleGetNotify={handleGetNotify}
                            key={item + index}
                            handleClose={handleClose}
                            update={update}
                            deleteItemByIndex={deleteItemByIndex}
                          />
                        </div>

                        {/* <span class="material-symbols-outlined deletSubTusk" onClick={() => deleteItemByIndex(index)}>delete</span> */}
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" onClick={() => deleteItemByIndex(index)}>
  <path d="M3.08594 13.2509C2.73145 13.2509 2.42798 13.1466 2.17554 12.9379C1.9231 12.7293 1.79688 12.4785 1.79688 12.1855V2.06481H0.916016V0.999467H4.95508V0.466797H10.627V0.999467H14.666V2.06481H13.7852V12.1855C13.7852 12.4696 13.6562 12.7182 13.3984 12.9313C13.1406 13.1444 12.8398 13.2509 12.4961 13.2509H3.08594ZM12.4961 2.06481H3.08594V12.1855H12.4961V2.06481ZM5.36328 10.6586H6.65234V3.57404H5.36328V10.6586ZM8.92969 10.6586H10.2187V3.57404H8.92969V10.6586Z" fill="#E62E7B"/>
</svg> */}
                      </div>
                    );
                  })}
                </div>


                {/* ====================== */}


                {/* <StatusEdit setStatus={setStatus} status={status} creatorTasks={allitem.creatorTasks} /> */}
                {(() => {
                  if (allitem.creatorTasks !== getmyinfo.getMayInfoReducer.myinfo._id) {
                    return (
                      <button onClick={handleStatus} className="confirmEditDate">Сдать работу</button>
                    )
                  }
                })()}
               

                {/* <MetkaEdit setMetka={setMetka} metka={metka} /> */}
                <CommentBox setComments={setComments} comments={comments} key={"ASDASDASDASD"} isChild={false} allitem={allitem} editAllTask={editAllTask} update={update} onlineUsers={onlineUsers} />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button variant="secondary" onClick={() => [handleCloseModal()]}>
              Закрыть
            </Button>
            {
              load ?
                <Button
                  isLoading
                  loadingText='Загрузка'
                  colorScheme='teal'
                  variant='outline'
                >
                  Submit
                </Button>
                :
                <button className="EditSaveBtn" onClick={sendServer}> Сохранить</button>
            }
          </div>
        </div>

      </div>


    </div>
  )
}

export default ModalEditTask;
